import { Grid, GridDirection, SxProps, Theme, styled, useTheme } from "@mui/material";
import React from "react";
import { ICustomerPortalTheme } from "../../entities/CustomerPortalTheme";

interface IButtonGroupProps {
  children: React.JSX.Element[];
  addClassName?: string;
  topBorder?: boolean;
  direction?: GridDirection;
  sx?: SxProps<Theme>;
}

const StyledGrid = styled(Grid)`
  margin-top: 15px;

  & button {
    /* Stand-alone buttons have 15px - this pulls the margins into the parent, making the DOM cleaner */
    margin-top: 0;
  }
`;

export const AquariusButtonGroup = ({
  children,
  sx,
  direction = "row",
  topBorder,
  addClassName,
  ...props
}: IButtonGroupProps): React.JSX.Element => {
  const theme = useTheme<ICustomerPortalTheme>();
  return (
    <StyledGrid
      container
      direction={direction}
      className={addClassName}
      spacing={"10px"}
      width="100% !important"
      marginLeft={"0px !important"}
      sx={{
        "& div:first-of-type": {
          padding: "0px !important",
        },
        ...(direction !== "column" && {
          "& .MuiGrid-item": { paddingTop: "0px" },
        }),
        ...(topBorder && {
          borderTop: `1px solid ${theme.modernLineDividers}`,
          paddingTop: "15px",
        }),
        ...sx,
      }}
      {...props}
    >
      {children?.map((e: any, i: number) => {
        return (
          <Grid item key={i} xs={6} md={6}>
            {e}
          </Grid>
        );
      })}
    </StyledGrid>
  );
};
